class CollectionFilters extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.sidebar = this.querySelector('[data-collection-filters-sidebar]');
    this.toggle = document.querySelector('[data-collection-filters-toggle]');

    this.addEventListener('change', this.onFilterChange.bind(this));

    if (this.toggle && this.sidebar) {
      this.toggle.addEventListener('click', () => {
        this.sidebar.classList.toggle('show');
      });
    }

    this.querySelectorAll('[data-collection-filters-group-title]').forEach((title) => {
      title.addEventListener('click', () => {
        const expanded = title.getAttribute('aria-expanded') === 'true';
        title.setAttribute('aria-expanded', String(!expanded));
      });
    });
  }

  onFilterChange(event) {
    if (event.target.matches('input[type="checkbox"], select, .collection-filters__price-input')) {
      this.form.requestSubmit();
    }
  }
}

customElements.define('collection-filters', CollectionFilters);

class PriceRangeFilter extends HTMLElement {
  connectedCallback() {
    this.minInput = this.querySelector('[data-price-min-input]');
    this.maxInput = this.querySelector('[data-price-max-input]');
    this.rangeMin = Number(this.dataset.rangeMin) || 0;
    this.rangeMax = Number(this.dataset.rangeMax) || 0;

    this.minInput.addEventListener('change', () => this.onNumberChange('min'));
    this.maxInput.addEventListener('change', () => this.onNumberChange('max'));
  }

  parseAmount(value) {
    const parsed = parseFloat(String(value).replace(/\s/g, '').replace(',', '.'));
    return Number.isNaN(parsed) ? null : parsed;
  }

  onNumberChange(which) {
    const input = which === 'min' ? this.minInput : this.maxInput;
    const amount = this.parseAmount(input.value);

    if (amount === null) {
      input.value = '';
    } else {
      input.value = Math.min(Math.max(amount, this.rangeMin), this.rangeMax);
    }
  }
}

customElements.define('price-range-filter', PriceRangeFilter);
